<div [ngClass]="getWrapClassList()">
  <app-label
    *ngIf="label"
    [id]="id"
    [label]="label"
    [required]="required"
    [tooltip]="tooltip"
    [ngClass]="getLabelClassList()"
    [colorLabel]="colorLabel"
  ></app-label>
  <div [ngClass]="getInputClassList()">
    <div class="d-flex">
      <ng-content></ng-content>
      <input
        [ngStyle]="{ 'border-color': borderColor, 'border-radius': borderRadius }"
        appNumeric
        [numericType]="numeric"
        [precision]="precision"
        [minPrecision]="minPrecision ?? 0"
        [shouldConvertToNegative]="shouldConvertToNegative"
        [forbidZeroValue]="forbidZeroValue"
        [textZeroValue]="textZeroValue"
        [class.input-bg-white]="theme === 'white'"
        [class.input-bg-grey]="theme === 'grey' || readonly"
        [class.input-db-left]="dbLeft"
        [class.input-db-right]="dbRight"
        appCut
        [cutSymbols]="cutSymbols"
        trim="blur"
        [ngClass]="{ 'form-control': true, private: private }"
        [class]="getInputColorClass()"
        [type]="getInputType()"
        [formControl]="formControl"
        [placeholder]="placeholder"
        [readonly]="readonly"
        [id]="id"
        [name]="name"
        [attr.disabled]="disabled ? '' : null"
        [maxLength]="maxLength"
        [autocomplete]="autocomplete"
        (focusin)="focusinHandler()"
        (focusout)="focusoutHandler()"
      />
    </div>

    <span
      *ngIf="clearable && !private && formControl.value !== null && formControl.enabled"
      (click)="clear()"
      [class.__clear-span-right-with-icon]="showIcon"
      [class.__clear-span-right-without-icon]="!showIcon"
      class="__clear-span black-clear-icon-content"
    ></span>
    <i *ngIf="showIcon && icon" [ngClass]="getIconClass()" class="i search wh-20" aria-hidden="true" (click)="iconEvent.emit()"></i>
    <i *ngIf="private" class="fa fa-eye" aria-hidden="true" (click)="view()"></i>

    <app-control-errors
      [control]="formControl"
      [touched]="!formControl.untouched"
      [errorMessages]="errorMessages"
      [error]="error"
    ></app-control-errors>
  </div>
</div>
